/* K BEAUTY — theme interactions */
(function () {
  "use strict";

  document.documentElement.classList.add("js");

  const header = document.querySelector(".header");
  const hero = document.querySelector(".hero");
  let lastY = window.scrollY;
  let headerTicking = false;
  const update = () => {
    headerTicking = false;
    if (!header) return;
    const y = window.scrollY;
    const overHero = hero ? y < window.innerHeight * 0.55 : y <= 10;
    header.classList.toggle("is-scrolled", !overHero);
    if (y > lastY && y > 220) header.classList.add("is-hidden");
    else header.classList.remove("is-hidden");
    lastY = y;
  };
  const onScroll = () => {
    if (!headerTicking) { headerTicking = true; requestAnimationFrame(update); }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  update();

  /* Mobile menu (hamburger) */
  const menuToggle = document.querySelector("[data-mobile-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  if (menuToggle && mobileMenu) {
    const closeMenu = () => {
      mobileMenu.classList.remove("is-open");
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.classList.remove("is-active");
    };
    menuToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = mobileMenu.classList.toggle("is-open");
      menuToggle.classList.toggle("is-active", open);
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    mobileMenu.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeMenu));
    document.addEventListener("click", (e) => {
      if (!mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) closeMenu();
    });
  }

  const revealEls = Array.from(document.querySelectorAll(".reveal"));
  let ticking = false;
  const checkReveals = () => {
    ticking = false;
    const vh = window.innerHeight;
    for (let i = revealEls.length - 1; i >= 0; i--) {
      const el = revealEls[i];
      const r = el.getBoundingClientRect();
      if (r.top < vh - 40 && r.bottom > 0) {
        el.classList.add("is-in");
        revealEls.splice(i, 1);
      }
    }
  };
  const queueReveal = () => {
    if (!ticking) { ticking = true; requestAnimationFrame(checkReveals); }
  };
  ["scroll", "resize", "load"].forEach((ev) => window.addEventListener(ev, queueReveal, { passive: true }));
  queueReveal();
  setInterval(queueReveal, 600);

  document.querySelectorAll(".faq__item, .acc__item").forEach((item) => {
    const q = item.querySelector(".faq__q, .acc__q");
    const a = item.querySelector(".faq__a, .acc__a");
    if (!q || !a) return;
    q.addEventListener("click", () => {
      const open = item.classList.toggle("is-open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
    });
  });

  const mainImg = document.querySelector("[data-gallery-main]");
  document.querySelectorAll("[data-gallery-thumb]").forEach((t) => {
    t.addEventListener("click", () => {
      document.querySelectorAll("[data-gallery-thumb]").forEach((x) => x.classList.remove("is-active"));
      t.classList.add("is-active");
      if (mainImg) {
        mainImg.style.opacity = 0;
        setTimeout(() => {
          mainImg.src = t.dataset.galleryThumb;
          mainImg.style.opacity = 1;
        }, 180);
      }
    });
  });

  const variantInput = document.querySelector("[data-variant-input]");
  const fmt = (n) => {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
      const parts = new Intl.NumberFormat(document.documentElement.lang || "es", { style: "currency", currency: cur }).formatToParts(n);
      const sym = (parts.find((p) => p.type === "currency") || {}).value || "€";
      const num = parts.filter((p) => ["integer", "group", "decimal", "fraction"].indexOf(p.type) > -1).map((p) => p.value).join("");
      return sym + num;
    } catch (e) {
      return "€" + n.toFixed(2).replace(".", ",");
    }
  };
  const subEl = document.querySelector("[data-subtotal]");
  const instEl = document.querySelector("[data-installment]");
  const qtyInput = document.querySelector("[data-qty-input]");
  const currentBase = () => {
    const active = document.querySelector(".tier.is-active");
    if (active) return { total: parseFloat(active.dataset.total), compare: parseFloat(active.dataset.comparetotal) };
    if (subEl) return { total: parseFloat(subEl.dataset.unitPrice), compare: parseFloat(subEl.dataset.comparePrice) };
    return { total: NaN, compare: NaN };
  };
  const updateSubtotal = () => {
    if (!subEl) return;
    const base = currentBase();
    const qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    if (isNaN(base.total)) return;
    subEl.textContent = fmt(base.total * qty);
    if (instEl) instEl.textContent = fmt((base.total * qty) / (parseInt(instEl.dataset.installmentCount, 10) || 3));
  };
  const syncPrices = () => {
    const base = currentBase();
    if (!isNaN(base.total)) {
      const was = base.compare > base.total ? base.compare : 0;
      const pct = was ? Math.floor(((was - base.total) * 100) / was) : 0;
      document.querySelectorAll(".buybox [data-price], .stickybar [data-price]").forEach((el) => { el.textContent = fmt(base.total); });
      document.querySelectorAll(".buybox [data-compare], .stickybar [data-compare]").forEach((el) => {
        if (was) { el.textContent = fmt(was); el.style.display = ""; } else el.style.display = "none";
      });
      document.querySelectorAll(".buybox [data-save], .stickybar [data-save]").forEach((el) => {
        if (pct > 0) { el.textContent = "Ahorra " + pct + "%"; el.style.display = ""; } else el.style.display = "none";
      });
    }
    updateSubtotal();
  };
  const qtyMinus = document.querySelector("[data-qty-minus]");
  const qtyPlus = document.querySelector("[data-qty-plus]");
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener("click", () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); updateSubtotal(); });
    qtyPlus.addEventListener("click", () => { qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1); updateSubtotal(); });
  }
  const kitOpts = document.querySelectorAll(".kit__opt, .tier");
  kitOpts.forEach((opt) => {
    opt.addEventListener("click", () => {
      kitOpts.forEach((o) => o.classList.remove("is-active"));
      opt.classList.add("is-active");
      if (variantInput && opt.dataset.variantId) variantInput.value = opt.dataset.variantId;
      syncPrices();
    });
  });
  syncPrices();

  const sticky = document.querySelector(".stickybar");
  const buyBtn = document.querySelector("[data-buy]");
  if (sticky && buyBtn) {
    const watch = new IntersectionObserver(
      ([e]) => sticky.classList.toggle("is-visible", !e.isIntersecting && window.scrollY > 300),
      { threshold: 0 }
    );
    watch.observe(buyBtn);
  }
})();